import { DataFieldType } from '../../../../shared/api/api';

export const defaultRange = {
  min: '',
  max: '',
};

export const filterFields = {
  region: { name: 'region', defaultValue: 'GLB' },
  delay: {
    name: 'delay',
    defaultValue: '1',
  },
  search: { name: 'search', defaultValue: '' },
  valueScore: { name: 'valueScore', defaultValue: defaultRange, validations: { min: 0 } },
  alphaCount: { name: 'alphaCount', defaultValue: defaultRange, validations: { min: 0 } },
  category: { name: 'category', defaultValue: '' },
  subcategory: { name: 'subcategory', defaultValue: '' },
  theme: { name: 'theme', defaultValue: [] as string[] },
  type: { name: 'type', defaultValue: 'all' as const },
  datasetId: { name: 'dataset.id', defaultValue: '' },
  universe: { name: 'universe', defaultValue: 'TOP3000' },
  instrument: { name: 'instrumentType', defaultValue: 'EQUITY' },
  dateCreated: { name: 'dateCreated', defaultValue: { start: '', end: '' } },
  dateUpdated: { name: 'dateUpdated', defaultValue: { start: '', end: '' } },
} as const;

const FIELD_TYPE_LABELS = new Map<DataFieldType, string>([
  ['MATRIX', 'Matrix'],
  ['VECTOR', 'Vector'],
  ['GROUP', 'Group'],
  ['UNIVERSE', 'Universe'],
  ['SYMBOL', 'Symbol'],
]);

export const fieldTypeOptions = [
  { value: filterFields.type.defaultValue, text: 'All' },
  ...Array.from(FIELD_TYPE_LABELS.entries()).map(([key, value]) => ({ value: key, text: value })),
] as { value: DataFieldType | typeof filterFields.type.defaultValue; text: string }[];

export const formatDataFieldType = (type?: DataFieldType) => (type ? FIELD_TYPE_LABELS.get(type) : '');
